import { ethers } from 'ethers'
import { getTokenAbi,  } from '../app/tokenAbi'
import { provider } from '../app/contracts';
import { getWalletContext } from '../contexts/walletContext';
import { getAllPoolsContext } from '../contexts/raidContext';
import { getPrices } from '../utilities/getPrices'
import { createLpContext } from '../contexts/lpContext';
import { createSymContext } from '../contexts/getSymContext';

export const getWalletBalances = async(walletAddress:any) => {
    const walletCallResponse = await getWalletContext(walletAddress)
    const tokenPrices = await getPrices()


    for (let token of Object.keys(tokenPrices)){
        tokenPrices[token.toUpperCase()] = tokenPrices[token];
        delete tokenPrices[token]
    }

    var newObj:any = {}
    const secondaryObj:any = {}

    for(const value of Object.values(walletCallResponse.results)){
        const totalSupply = ethers.utils.formatEther(value.callsReturnContext[2].returnValues[0])
        if(value.callsReturnContext[0].returnValues[0] === 'Cake-LP'){
            const poolIndex = value.originalContractCallContext.context.poolIndex
            newObj[poolIndex] = {
                sym: value.callsReturnContext[0].returnValues[0],
                address: value.originalContractCallContext.context.address,
                poolIndex: value.originalContractCallContext.context.poolIndex,
                totalSupply: totalSupply
            }
            secondaryObj[poolIndex] = value.originalContractCallContext.context.address
        }
        for(const[token, price] of Object.entries(tokenPrices)){
            if(token === value.callsReturnContext[0].returnValues[0]){
                const sym = token
                const tokensInWallet:any = ethers.utils.formatEther(value.callsReturnContext[1].returnValues[0])
                const price1:any = price
                const walletValueInDollars = price1 * tokensInWallet
                const poolIndex = value.originalContractCallContext.context.poolIndex
                newObj[poolIndex] = {
                    sym:sym,
                    address:value.callsReturnContext[0].reference,
                    price:price1,
                    tokensInWallet:tokensInWallet,
                    walletValueInDollars:walletValueInDollars,
                    poolIndex: value.originalContractCallContext.context.poolIndex,
                    totalSupply: totalSupply
                }
            }
        }
    }

    //build a an array of all lp pools without single tokens (eg. [[0,0x...],[1,0x...],[3,0x...],[4,0x...]...[66,0x...]])
    const newArr:any = []
    for(const [key, value] of Object.entries(secondaryObj)){
        const tempArr = []
        tempArr.push(key)
        tempArr.push(value)
        newArr.push(tempArr)
    }

    const lpContext = createLpContext(await newArr, await walletAddress)
    const result = await lpContext
    const lpTokenArrays:any = []
    const poolIndexArr:any = []
    
    for(const[key,value] of Object.entries(result.results)){
        poolIndexArr.push(key)
        poolIndexArr.push(key)
        const token0 = value.callsReturnContext[1].returnValues[0]
        const token1 = value.callsReturnContext[2].returnValues[0]
        const amountInWallet = ethers.utils.formatEther(value.callsReturnContext[4].returnValues[0])
        newObj[key]= {...newObj[key], tokensInWallet: amountInWallet, token0:token0, token1:token1}
        lpTokenArrays.push(await value.callsReturnContext[1].returnValues[0])
        lpTokenArrays.push(await value.callsReturnContext[2].returnValues[0])
    }

    const symContext:any = await createSymContext(lpTokenArrays, poolIndexArr)
    const symResult:any = await symContext.results
    for(const result of Object.values(await symResult)){
        const value1:any = await result
        for(const key1 of Object.keys(await newObj)){
            if (value1.originalContractCallContext.context.poolIndex === key1.toString()){
                const num:any = value1.originalContractCallContext.context.token
                newObj[key1] = {...newObj[key1], [num]:value1.callsReturnContext[0].returnValues[0]}
            }
        }
    }
    
    for(const [key, value] of Object.entries(await newObj)){
        const value1:any = value
        if(value1.sym === 'Cake-LP'){
            newObj[key] = {...newObj[key], sym:`${value1[0]}-${value1[1]} LP`}
        }
    }

    const contractCallResponse = await getAllPoolsContext(walletAddress)
    const stakedArray:any = []
    const arrayOfAllocations = contractCallResponse.results.getAllocationAmounts.callsReturnContext
    arrayOfAllocations.map(async (returnObj) => {
        const allocationAmount = ethers.utils.formatEther(returnObj.returnValues[0])
        if (allocationAmount !== '0.0'){
            newObj[returnObj.methodParameters[0]] = {...newObj[returnObj.methodParameters[0]], stakeAllocationAmount: allocationAmount}
            const poolIndex = returnObj.methodParameters[0]
            stakedArray.push(poolIndex)
        }
    })

    for(const [key, value] of Object.entries(newObj)){
        const value1:any = value
        if(value1.stakeAllocationAmount && value1.sym.includes('LP')){
            const address = value1.address
            const newContractTest = new ethers.Contract(await address, getTokenAbi(), provider)
            const reserves = await newContractTest.getReserves()
            const reserves0 = ethers.utils.formatEther(reserves[0])
            const reserves1 = ethers.utils.formatEther(reserves[1])
            newObj[key] = {...newObj[key], reserves0:reserves0, reserves1:reserves1}
        }
    }

    for(const [key, value] of Object.entries(newObj)){
        const value1:any = value
        if(value1.stakeAllocationAmount && value1.sym.includes('LP')){
            for(const [token, price] of Object.entries(tokenPrices)){
                if(token === value1[0]){
                    newObj[key] = {...newObj[key], price0:price}
                }else if(token === value1[1]){
                    newObj[key] = {...newObj[key], price1:price}
                }
            }
        }
    }

    for(const [key, value] of Object.entries(newObj)){
        const value1:any = value
        if(value1.stakeAllocationAmount && value1.sym.includes('LP')){
            const amountStaked = Number(value1.stakeAllocationAmount)
            const totalSupply = Number(value1.totalSupply)
            const reserves0 = Number(value1.reserves0)
            const reserves1 = Number(value1.reserves1)
            const percentOfPool = amountStaked/totalSupply
            const amountOfToken0 = percentOfPool * reserves0
            const amountOfToken1 = percentOfPool * reserves1
            const valueOfToken0Amount = amountOfToken0 * value1.price0
            const valueOfToken1Amount = amountOfToken1 * value1.price1
            const totalValueInPool = valueOfToken0Amount + valueOfToken1Amount
            newObj[key] = {...newObj[key], amountOfToken0:amountOfToken0, amountOfToken1:amountOfToken1, valueOfToken0Amount:valueOfToken0Amount, valueOfToken1Amount:valueOfToken1Amount, totalValueInPool:totalValueInPool}
        }else if(value1.stakeAllocationAmount && value1.price){
            const amountStaked = Number(value1.stakeAllocationAmount)
            const totalValueInPool = amountStaked * value1.price
            newObj[key] = {...newObj[key], totalValueInPool:totalValueInPool}
        }
    }

    const balanceOfBnbBn = await provider.getBalance('0x9F5Dbe074fece38122559aCF226ECb910B64B6C5')
    const balanceOfBnb:any = ethers.utils.formatEther(balanceOfBnbBn)
    const priceOfBnb = tokenPrices['WBNB']
    const walletValue = priceOfBnb * balanceOfBnb
    if(balanceOfBnb){
        newObj['72'] = {sym:'BNB', poolIndex:'72', price:priceOfBnb, tokensInWallet:balanceOfBnb, walletValueInDollars:walletValue}
    }

    return(newObj)
}